import React, { useContext, useEffect, useState } from 'react'
import { RequestContext } from '../../../../context/RequestContext';
import { FaQuestionCircle } from 'react-icons/fa';
import { openModal } from '../../../../service/modal-service';
import { AirconServiceGuide } from './AirconServiceGuide';
import { BookingCard, BookingFooter, PriceTileGrid, ServiceTypeTabs, getServiceTheme } from './AirconBookingLayout';

const SERVICE_TABS = [
    { value: 'general', label: ['General', 'Service'], ariaLabel: 'Select General Aircon Servicing' },
    { value: 'chemicalWash', label: ['Chemical', 'Wash'], ariaLabel: 'Select Chemical Wash Aircon Servicing' },
    { value: 'chemicalOverhaul', label: ['Chemical', 'Overhaul'], ariaLabel: 'Select Chemical Overhaul Aircon Servicing' },
]

export const AirconBooking = (props) => {
    const setRequestForm = props.setRequestForm
    const oneTimeServicing = props.oneTimeServicing
    const chemicalServicing = props.chemicalServicing
    const overhaulServicing = props.overhaulServicing
    const setIsQuickBook = props.setIsQuickBook
    const setIsCustomBook = props.setIsCustomBook
    const showJobScope = props.showJobScope
    const title = props.title
    // Optional. Only pass this where the claim is actually true for that page -
    // this component is shared by 11 aircon pages with different pricing.
    const subtitle = props.subtitle

    const setIsShowAirconItemSelection = props.setIsShowAirconItemSelection

    const [ servicing, setServicing ] = useState(props.oneTimeServicing)
    const [ serviceType, setServiceType] = useState(props.serviceType || 'general')
    const [ unitType, setUnitType] = useState(props.unitType || 'Wall')
    const [ isShowAirconGuide, setIsShowAirconGuide ] = useState(false)

    const { setRequestCriteria, setRequestDescription, setServiceSummary } = useContext(RequestContext);

    const confirmBook = (criteria) => {
        setRequestCriteria(criteria)
        setRequestDescription('Aircon Service')
        setIsQuickBook(true)
        // A quick book is not a custom (picker) booking, whatever came before
        setIsCustomBook(false)
        openModal(setRequestForm)
    }
    
    const quickBook = (airconCount) => {

        let criteria = [
            {1: 'General servicing for cleaning', criteria: 'Type of service - General servicing for cleaning'},
            {2: airconCount.toString(), criteria: "Number of aircon units to be serviced - " + airconCount},
            {21: 'Only once', criteria: 'Frequency of service - Only once'},
            {24: 'Wall', criteria: 'Mount type - Wall'}
        ]
        
        if(serviceType === "chemicalWash"){
            criteria = 
                [
                    {1: 'Chemical cleaning', criteria: 'Type of service - Chemical cleaning'},
                    {2: airconCount.toString(), criteria: "Number of aircon units to be serviced - " + airconCount},
                    {3: 'Basic chemical wash (partial dismantling may be needed)', criteria: 'Basic chemical wash (partial dismantling may be needed)'},
                    {21: 'Only once', criteria: 'Frequency of service - Only once'},
                    {24: 'Wall', criteria: 'Mount type - Wall'}
                ]
        } 
        
        if(serviceType === "chemicalOverhaul"){
            criteria = 
                [
                    {1: 'Chemical cleaning', criteria: 'Type of service - Chemical cleaning'},
                    {2: airconCount.toString(), criteria: "Number of aircon units to be serviced - " + airconCount},
                    {3: 'Chemical overhaul (deeper cleaning by dismantling)', criteria: 'Chemical overhaul (deeper cleaning by dismantling)'},
                    {21: 'Only once', criteria: 'Frequency of service - Only once'},
                    {24: 'Wall', criteria: 'Mount type - Wall'}
                ]
        }
        confirmBook(criteria)
    }

    useEffect(() => {
        setRequestCriteria([])
        setRequestDescription('')
        setServiceSummary('')
        setIsQuickBook(false)
        setIsCustomBook(false)
    }, [setIsQuickBook, setRequestCriteria, setRequestDescription, setServiceSummary, setIsCustomBook])

    const changeServiceType = (serviceType) => {
        setServiceType(serviceType)
    }

    useEffect(() => {
        switch (serviceType) {
            case "general":
                setServicing(oneTimeServicing)
                break;
            case "chemicalWash":
                setServicing(chemicalServicing)
                break;
            case "chemicalOverhaul":
                setServicing(overhaulServicing)
                break;
            default:
                setServicing(oneTimeServicing)
                break;
        }
    }, [serviceType, setServicing, chemicalServicing, oneTimeServicing, overhaulServicing])

    const theme = getServiceTheme(serviceType)

    const tiles = [0,1,2,3,4].map(i => ({
        key: `${serviceType}-${i}`,
        label: `${i + 1} AC unit${i > 0 ? 's' : ''}`,
        shortLabel: servicing[i].number,
        currencyCd: servicing[i].currencyCd,
        price: servicing[i].rate,
        ariaLabel: `Book ${servicing[i].number} aircon ${serviceType} servicing`,
        onBook: () => quickBook(i + 1),
    }))

  return (
    <>
        <BookingCard title={title} subtitle={subtitle}>
            <ServiceTypeTabs options={SERVICE_TABS} value={serviceType} onChange={changeServiceType}>
                <button type="button" className='text-orange-500 sm:text-white text-xl' onClick={() => setIsShowAirconGuide(true)} aria-label='Guide me through aircon servicing options'>
                    <FaQuestionCircle/>
                </button>
            </ServiceTypeTabs>

            {/* Booking buttons */}
            <div className='pt-4 pb-2 px-4'>
                <PriceTileGrid
                    tiles={tiles}
                    theme={theme}
                    onMore={() => setIsShowAirconItemSelection(true)}
                />
                <BookingFooter
                    theme={theme}
                    serviceType={serviceType}
                    onShowDetails={() => showJobScope(serviceType, unitType)}
                    highlights={[serviceType === 'general' ? '30 days warranty' : '60 days warranty', 'Transport Included']}
                />
            </div>
        </BookingCard>
        {isShowAirconGuide &&
            <AirconServiceGuide setIsShowAirconGuide={setIsShowAirconGuide} />
        }    
    </>
  )
}
